
import { Offcanvas } from 'bootstrap';

/**
 * Offcanvas
 */
export function initOffcanvas(elem) {
    let offcanvasTriggerList = [].slice.call(elem.querySelectorAll(".offcanvas"));
    offcanvasTriggerList.map(function (offcanvasTriggerEl) {
        return new Offcanvas(offcanvasTriggerEl);
    });
}
initOffcanvas(document);
